import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./HomeNewBeauty.css";

const API_BASE_URL = "https://volumaire.backendapihub.com/api";
// Use the same default image as in your Influencer section
const DEFAULT_IMAGE = "/images/dailyroutine2.webp";

function HomeNewBeauty() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);

        const params = new URLSearchParams({
          page: "1",
          limit: "10",
          subcategoryId: "3",
          countryCode: "IN",
          search: "",
        });

        const url = `${API_BASE_URL}/complete-products?${params}`;
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`API error: ${response.status}`);
        }
        const data = await response.json();

        // ----- SAFE PRODUCT ARRAY EXTRACTION -----
        let productsArray = [];

        // Try the most likely path first: data.data.products
        if (data?.data?.products && Array.isArray(data.data.products)) {
          productsArray = data.data.products;
        }
        // Fallback: direct data.products
        else if (data?.products && Array.isArray(data.products)) {
          productsArray = data.products;
        }
        // Fallback: data.data itself is an array
        else if (data?.data && Array.isArray(data.data)) {
          productsArray = data.data;
        }
        // Fallback: data itself is an array
        else if (Array.isArray(data)) {
          productsArray = data;
        }
        // Last resort: search for any array-valued property
        else {
          const possibleArray = Object.values(data || {}).find(Array.isArray) ||
                                Object.values(data?.data || {}).find(Array.isArray);
          if (possibleArray) {
            productsArray = possibleArray;
          } else {
            console.warn("Could not find products array in response:", data);
          }
        }

        // Final safety: ensure it's an array
        if (!Array.isArray(productsArray)) {
          productsArray = [];
        }

        // Transform each product and set a valid image (use DEFAULT_IMAGE if missing/broken)
        const transformedProducts = productsArray.map((item) => {
          // Determine the best available image URL
          let imageUrl = DEFAULT_IMAGE;
          const rawImage = item.images?.[0];
          
          if (rawImage && typeof rawImage === 'string' && rawImage.trim() !== '') {
            // Build absolute URL if needed
            if (rawImage.startsWith('http')) {
              imageUrl = rawImage;
            } else if (rawImage.startsWith('/')) {
              imageUrl = `https://volumaire.backendapihub.com${rawImage}`;
            } else {
              imageUrl = `https://volumaire.backendapihub.com/${rawImage}`;
            }
          }

          return {
            id: item.id,
            title: item.name,
            // Strip HTML tags from description (API sometimes returns HTML)
            desc: item.description ? item.description.replace(/<[^>]*>/g, '') : "",
            img: imageUrl, // guaranteed to be a string (real or default)
          };
        });

        // Only show the first 3 products
        setProducts(transformedProducts.slice(0, 3));
      } catch (err) {
        console.error("Failed to fetch new beauty products:", err);
        setError(err.message);
        setProducts([]); // fallback to empty array
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const handleProductClick = (productId) => {
    const scrollPosition = window.scrollY;
    localStorage.setItem("homeScrollPosition", scrollPosition);
    localStorage.setItem("fromNewBeautySection", "true");
    navigate(`/product/${productId}`);
  };

  const handleCheckNowClick = (e, productId) => {
    e.stopPropagation();
    const scrollPosition = window.scrollY;
    localStorage.setItem("homeScrollPosition", scrollPosition);
    localStorage.setItem("fromNewBeautySection", "true");
    navigate(`/product/${productId}`);
  };

  if (loading) {
    return (
      <section id="new-beauty-section" className="home-new-beauty">
        <h2 className="new-beauty-heading">New Beauty Products</h2>
        <div className="loading-indicator">Loading...</div>
      </section>
    );
  }

  if (error) {
    console.warn("Error loading new beauty products:", error);
  }

  return (
    <section id="new-beauty-section" className="home-new-beauty">
      <h2 className="new-beauty-heading">New Beauty Products</h2>

      <div className="new-beauty-grid">
        {products.map((item) => (
          <div
            className="new-beauty-card"
            key={item.id}
            onClick={() => handleProductClick(item.id)}
          >
            <div className="new-beauty-image">
              <img 
                src={item.img} 
                alt={item.title}
                onError={(e) => {
                  // If even the default image fails, keep using default (prevents infinite loop)
                  e.target.onerror = null;
                  e.target.src = DEFAULT_IMAGE;
                }}
              />
            </div>

            <h3 className="new-beauty-product-title">{item.title}</h3>
            {/* <p className="new-beauty-product-desc">{item.desc}</p> */}
            <span
              className="new-beauty-check-now"
              onClick={(e) => handleCheckNowClick(e, item.id)}
            >
              CHECK NOW
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default HomeNewBeauty;